import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ProviderStateService } from '../services/provider-state.service';
import { GraphqlService } from '../services/graphql.service';
import { ProviderData } from '../models/provider';

@Injectable({
  providedIn: 'root'
})
export class EgdproviderGuard implements CanActivate {

  private readonly defaultslug = 'eglobaldoctors';

  constructor(
    private router: Router,
    private readonly graphqlService: GraphqlService,
    private providerStateService: ProviderStateService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const slug = this.defaultslug;



    return this.graphqlService.findProvider(slug).pipe(
      switchMap(result => {
        const providerId = result?.id;
        console.log('Find Provider Result:', result);
        if (providerId) {
          return this.graphqlService.fetchProviderMetadata(providerId).pipe(
            map(metadata => {
              console.log('Fetch Provider Metadata:', metadata);
              if (metadata && metadata.provider) {
                const providerData: ProviderData = {
                  providerId: providerId,
                  name: metadata.provider.name,
                  isPrimaryProvider: metadata.provider.is_primary_provider,
                  logoUrl: metadata.metadata.images.logo.default,
                  slug: slug
                };
                console.log('Setting provider data:', providerData);
                this.providerStateService.setProviderData(providerData);
                return true;
              } else {
                console.error('Metadata or provider is missing:', metadata);
                this.router.navigate(['/notfound']);
                return false;
              }
            }),
            catchError((error) => {
              console.error('Error fetching provider metadata:', error);
              this.router.navigate(['/notfound']);
              return of(false);
            })
          );
        } else {
          console.error('Provider ID mismatch or provider not found:', result);
          this.router.navigate(['/notfound']);
          return of(false);
        }
      }),
      catchError((error) => {
        console.error('Error finding provider:', error);
        this.router.navigate(['/notfound']);
        return of(false);
      }),
      tap(canActivate => {
        if (!canActivate) {
          this.router.navigate(['/notfound']);
        }
      })
    );
  }
}

